export const PERMS = {
    READ: 'invoice_item_types.read',
    UPDATE: 'invoice_item_types.update',
    DELETE: 'invoice_item_types.delete',
    CREATE: 'invoice_item_types.create',
    EXPORT: 'invoice_item_types.export',
}
